import { render, staticRenderFns } from "./NewCard.vue?vue&type=template&id=3e31cad4&scoped=true&"
import script from "./NewCard.vue?vue&type=script&lang=js&"
export * from "./NewCard.vue?vue&type=script&lang=js&"
import style0 from "./NewCard.vue?vue&type=style&index=0&id=3e31cad4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e31cad4",
  null
  
)

export default component.exports